<template>
  <div id="app" class="page">
    <header class="hero">
      <div>
        <p class="eyebrow">DGrid lookup</p>
        <h1>Query addresses and view the status</h1>
        <p class="lede">
          Enter addresses to check online status.
        </p>
      </div>
    </header>

    <AddressLookup />
  </div>
</template>

<script>
import AddressLookup from './components/AddressLookup.vue'

export default {
  name: 'App',
  components: {
    AddressLookup
  }
}
</script>

<style>
:root {
  color-scheme: light;
  --bg: #0f172a;
  --card: #111827;
  --text: #e5e7eb;
  --muted: #94a3b8;
  --accent: #22d3ee;
  --border: #1f2937;
  --pill-ok: #34d399;
  --pill-miss: #f87171;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: radial-gradient(circle at 20% 20%, #1e293b 0, #0b1222 40%, #050914 80%);
}

#app {
  font-family: 'DM Mono', 'SFMono-Regular', Menlo, Monaco, Consolas, monospace;
  color: var(--text);
  min-height: 100vh;
  padding: 32px;
}

.page {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.hero {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.eyebrow {
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 12px;
  color: var(--muted);
  margin: 0 0 8px 0;
}

h1 {
  margin: 0 0 8px 0;
  font-size: 32px;
  color: #e2e8f0;
}

.lede {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
}

@media (max-width: 640px) {
  #app {
    padding: 20px;
  }
}
</style>
